import { AHIcon, Circle, useLayoutContext, useScaleFactor } from "arkh";
import React from "react";
import { Pressable } from "react-native";

export function ProductExpireBatchActionCheck(props: {
  onPress: () => void;
  status: "COMPLETED" | "PENDING";
  activeAction: boolean;
  hasStarted: boolean;
}) {
  const sf = useScaleFactor();
  const layout = useLayoutContext();
  return (
    <Pressable
      onPress={props.onPress}
      style={({ pressed }) => ({
        opacity: pressed ? 0.5 : 1,
      })}
      hitSlop={{ top: 25, bottom: 25, left: 25, right: 25 }}
    >
      <Circle
        borderWidth={Math.max(1, Math.round(2 * sf))}
        size="medium"
        borderColor={
          props.status === "COMPLETED" ? "status-positive" : "text-washed"
        }
        color={props.status === "COMPLETED" ? "status-positive" : "transparent"}
        style={{
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
        }}
      >
        {props.status === "COMPLETED" ? (
          <AHIcon
            type="check"
            color="text-inverted"
            forceSize={layout.circle.medium * 0.5}
          />
        ) : null}
      </Circle>
    </Pressable>
  );
}
